import { NetworkRequestFailedError } from 'activate-errors';
import isThisError from './isThisError';

export default function isNetworkError(err: any) {
  return (
    isThisError(err, NetworkRequestFailedError) ||
    err.message.includes('Network request failed')
  );
}
